const Profile = () => import("./views/Profile.vue");

export default [
  {
    path: "/profile",
    name: "profile",
    component: Profile,

    meta: {
      roles: [
        "ROLE_PARENT",
        "ROLE_INSTITUTION_WORKER",
        "ROLE_ADMIN",
        "ROLE_INSTITUTIONS_ADMIN",
        "ROLE_COOK",
      ],
    },
  },
];
